export const aboutData = {
    title: "Who I am",
    description1: "My name's Prattay . I'm a web designer and developer based in Dhaka, Bangladesh.",
    description2: "Passionate junior front-end developer with a desire to learn and grow in a collaborative team environment.",
    image: 1
}